module.exports = __webpack_public_path__ + "img/gl-logo-mob.db67b204.png";